export default __webpack_public_path__ + "static/media/not-found-background.b04f1fd3.jpg";